import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { GlobalMessageService, GlobalMessageType, OccEndpointsService } from '@spartacus/core'
import { Observable } from 'rxjs'
import { catchError, tap } from 'rxjs/operators'

@Injectable()
export class EbProductDetailAdapter {
  constructor(
    private readonly http: HttpClient,
    private readonly occEndpointsService: OccEndpointsService,
    protected globalMessageService: GlobalMessageService
  ) {}

  sendRequestForQuotation(variantId: string): Observable<any> {
    const url = this.occEndpointsService.buildUrl('requestQuote', {
      urlParams: {
        productCode: variantId
      }
    })
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    return this.http.post(url, {}, { headers }).pipe(
      catchError(err => {
        return this.showErrorMessage(err)
      }),
      tap(() => this.showSuccessMessage())
    )
  }

  showSuccessMessage() {
    this.globalMessageService.add(
      { key: 'requestQuote.success' },
      GlobalMessageType.MSG_TYPE_CONFIRMATION
    )
  }

  showErrorMessage(err) {
    this.globalMessageService.add({ key: 'requestQuote.failure' }, GlobalMessageType.MSG_TYPE_ERROR)
    return err
  }
}
